<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-toolbar flat color="transparent" height="50">
                    <h3 v-if="selectedAccount" class="hidden-sm-and-down">
                        <v-btn flat fab small color="primary" class="link-button" @click="back">
                            <v-icon>arrow_back</v-icon>
                        </v-btn>
                        {{selectedAccount.name}}
                    </h3>
                    <h5 v-if="selectedAccount" class="hidden-md-and-up">
                        <v-btn flat fab small color="primary" class="link-button" @click="back">
                            <v-icon>arrow_back</v-icon>
                        </v-btn>
                        {{selectedAccount.name}}
                    </h5>
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="teal"
                        class="hidden-sm-and-down"
                        v-if="isDisplayEditButton"
                        @click="editAccountDialog = true"
                    >
                        Chỉnh sửa
                        <v-icon right dark>edit</v-icon>
                    </v-btn>
                    <v-btn
                        color="primary"
                        class="hidden-sm-and-down"
                        v-if="isDisplayUpdateDealerButton"
                        @click="updateDealerDialog = true"
                    >
                        Chuyển thành đại lý
                        <v-icon right dark>call_made</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-flex lg12>
                    <v-card>
                        <v-tabs
                            v-model="active"
                            fixed-tabs
                            slider-color="primary"
                            color="grey lighten-2"
                        >
                            <v-tab ripple>Khách hàng ({{accounts.length}})</v-tab>
                            <v-tab ripple>Xe ({{totalVehicle}})</v-tab>
                            <v-tab ripple>Thiết bị ({{totalDevice}})</v-tab>
                            <v-tab ripple>Người dùng ({{users.length}})</v-tab>
                        </v-tabs>
                        <v-tabs-items touchless v-model="active">
                            <v-tab-item>
                                <account-table
                                  :isLoading="isLoading"
                                  :datasource="accounts"
                                  :totalItems="totalAccount"
                                  :isFilter="false"
                                  @changePage="reloadAccountTable"
                                  @exportFile="openDialogExportFileAcount"
                                  @updateDtCode="updateDtCode"
                                />
                            </v-tab-item>
                            <v-tab-item>
                                <vehicle-table
                                  ref="vehicleTable"
                                  :isLoading="isLoading"
                                  :datasource="vehicles"
                                  :isFilter="false"
                                  :totalItems="totalVehicle"
                                  @changePage="reloadVehicleTable"
                                  @exportFile="openDialogExportFileVehicle"
                                />
                            </v-tab-item>
                            <v-tab-item>
                              <device-table
                                :isLoading="isLoading"
                                :totalItems="totalDevice"
                                :isFilter="false"
                                :datasource="devices"
                                @changePage="reloadDeviceTable"
                                @exportFile="openDialogExportFileDevice"
                                @renewed="refreshVehicleAfterRenew"
                              />
                            </v-tab-item>
                            <v-tab-item>
                                <user-table
                                    :isLoading="isLoading"
                                    :datasource="users"
                                    :totalVehicle="totalVehicle"
                                    @reload="reloadUserTable"
                                />
                            </v-tab-item>
                        </v-tabs-items>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-layout row justify-center>
            <!-- Update Account to Dealer -->
            <v-dialog v-model="updateDealerDialog" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">Chuyển thành đại lý?</v-card-title>
                    <v-card-text
                        v-if="selectedAccount"
                    >Bạn có chắc chắn muốn chuyển {{selectedAccount.name}} thành đại lý?</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @click.native="updateDealerDialog = false">Từ chối</v-btn>
                        <v-btn
                            color="primary"
                            flat
                            @click.native="updateAccountToDealerSubmit()"
                        >Đồng ý</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- Update Account to Dealer -->

            <!-- Edit Account -->
            <v-dialog v-model="editAccountDialog" persistent max-width="480">
                <edit-account :account="selectedAccount" @show="editAccountDialog = $event"></edit-account>
            </v-dialog>
            <!-- Edit Account -->
        </v-layout>
        <v-speed-dial
            bottom
            right
            fixed
            class="hidden-md-and-up"
            v-if="isDisplayUpdateDealerButton"
        >
            <v-btn slot="activator" color="blue darken-2" dark fab>
                <v-icon>call_made</v-icon>
            </v-btn>
        </v-speed-dial>

      <!-- Dialog xuất file -->
      <dialog-export-file ref="dialogExportFile" :loading="loadingExportFile" @export="handleExportFile"/>
      <!-- Dialog xuất file -->
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import API from '@/api/index';
import * as Utils from '@/utils';
import DeviceTable from '@/pages/device/components/list';
import VehicleTable from '@/pages/vehicle/components/list';
import AccountTable from './components/list';
import UserTable from './components/user';
import EditAccount from './components/edit';
import moment from 'moment';
import DialogExportFile from '@/components/dialog/DialogExportFile';
import XLSX from 'xlsx';

export default {
  components: {
    VehicleTable,
    DeviceTable,
    UserTable,
    AccountTable,
    EditAccount,
    DialogExportFile
  },
  data () {
    return {
      editAccountDialog: false,
      updateDealerDialog: false,
      active: null,
      isLoading: false,
      selectedAccount: null,
      accountId: null,
      paginationParams: null,
      vehicles: [],
      devices: [],
      users: [],
      accounts: [],
      loadingExportFile: false,
      fileName: 'Users',
      totalVehicle: 0,
      totalDevice: 0,
      totalAccount: 0
    };
  },

  computed: {
    ...mapGetters(['loggedUser']),
    isDisplayUpdateDealerButton () {
      return (
        this.loggedUser.isProvider &&
        this.selectedAccount &&
        !this.selectedAccount.isDealer &&
        !this.selectedAccount.isProvider &&
        !this.selectedAccount.isDistributor
      );
    },
    isDisplayEditButton () {
      return (
        this.loggedUser.isProvider &&
        this.selectedAccount
      );
    }
  },

  async created () {
    this.accountId = this.$route.query.accountId;
    this.paginationParams = Object.assign(
      { accountId: this.accountId },
      Utils.pagination
    );
    this.getAccountById(this.accountId).then(res => {
      this.selectedAccount = res;
    });

    let account = await this.getAccountById(this.accountId);
    let dtMap = await this.getDtMapping()
      .then(res => res.data || [])
      .catch(_ => []);

    let found = dtMap.find(x => x.accountId === this.accountId);
    account.dtCode = found ? found.code : '';

    this.selectedAccount = account;
      
    this.getUserByAccount(this.paginationParams).then(res => {
      this.users = res;
    });
  },
  methods: {
    ...mapActions([
      'getAccountById',
      'getDeviceByAccount',
      'getVehicleByAccount',
      'getUserByAccount',
      'getAccountByParent',
      'updateAccountToDealer',
      'getDtMapping',
      'createDtMapping'
    ]),
    back: _ => window.getApp.$emit('APP_PAGE_BACK'),
    updateAccountToDealerSubmit () {
      this.updateDealerDialog = false;
      this.updateAccountToDealer(this.selectedAccount.id)
        .then(res => {
          this.selectedAccount.isDealer = true;
          window.getApp.showMessage('Chuyển đại lý thành công');
        })
        .catch(_ => {
          window.getApp.showMessage(
            'Chuyển đại lý thất bại, vui lòng thử lại',
            'err'
          );
        });
    },
    reloadUserTable () {
      this.getUserByAccount(this.paginationParams).then(res => {
        this.users = res;
      });
    },
    reloadVehicleTable ({ params, typeFilter }) {
      let paramsVehicle = { ...params, ...{ accountId: this.paginationParams.accountId }};
      this.getVehicleByAccount(paramsVehicle).then(res => {
        console.log('reloadVehicleTable -> res', res);
        this.vehicles = res && res.data.map(a => {
          if (a.remainExpiryDay) { a['expiryDay'] = moment().add(a.remainExpiryDay, 'days').valueOf() }
          return a;
        });

        this.totalVehicle = res && res.totalRecords || 0;
      });
    },

    refreshVehicleAfterRenew () {
      this.active = 1;
      this.reloadVehicleTable({
        params: this.$refs.vehicleTable.params,
        typeFilter: this.$refs.vehicleTable.filter
      });
    },

    async reloadAccountTable (pagination) {
      let params = {
        accountId: this.paginationParams.accountId,
        keySearch: pagination.keySearch,
        pageIndex: this.paginationParams.pageIndex,
        pageSize: this.paginationParams.pageSize
      };

      let res = await this.getAccountByParent(params);
      let accounts = (res && res.data) || [];

      let dtMap = await this.getDtMapping()
        .then(r => r.data || [])
        .catch(_ => []);

      let mapByAccount = {};
      dtMap.forEach(x => {
        mapByAccount[x.accountId] = x.code;
      });

      accounts = accounts.map(acc => ({
        ...acc,
        dtCode: mapByAccount[acc.id] || ''
      }));

      this.accounts = accounts;
      this.totalAccount = res.totalRecords || 0;
    },

    reloadDeviceTable (pagination) {
      let params = { ...pagination, ...{ accountId: this.paginationParams.accountId }};
      this.getDeviceByAccount(params).then(res => {
        this.devices = res && res.data || [];
        this.totalDevice = res && res.totalRecords || 0;
      });
    },

    getDateFormatted (value) {
      return this.$refs.vehicleTable.getDateFormatted(value);
    },

    getVehicleStatus (value) {
      return this.$refs.vehicleTable.getVehicleStatus(value);
    },

    openDialogExportFileVehicle () {
      this.fileName = `Vehicles`;
      let countExportFile = Math.ceil(this.totalVehicle / 10000);
      this.$refs.dialogExportFile.open(countExportFile, this.fileName);
    },

    openDialogExportFileDevice () {
      this.fileName = `Devices`;
      let countExportFile = Math.ceil(this.totalDevice / 10000);
      this.$refs.dialogExportFile.open(countExportFile, this.fileName);
    },

    openDialogExportFileAcount () {
      this.fileName = `Accounts`;
      let countExportFile = Math.ceil(this.totalAccount / 10000);
      this.$refs.dialogExportFile.open(countExportFile, this.fileName);
    },

    async handleExportFile (file) {
      let dataToExport = [];
      switch (this.fileName) {
        case 'Accounts': {
          dataToExport = await this.exportFileAccount(file);
          break;
        }
        case 'Vehicles': {
          dataToExport = await this.exportFileVehicle(file);
          break;
        }
        case 'Devices': {
          dataToExport = await this.exportFileDevice(file);
          break;
        }
        default: break;
      }


      let sheet = XLSX.utils.json_to_sheet(dataToExport);
      let wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, sheet, this.fileName);
      XLSX.writeFile(wb, `${file.name}.xlsx`);
    },

    async exportFileVehicle (file) {
      let params = {
        accountId: this.paginationParams.accountId,
        keySearch: '',
        pageIndex: file.index,
        pageSize: 10000,
      };

      params[this.typeFilter] = true;

      this.loadingExportFile = true;

      let list = await this.getVehicleByAccount(params).then(res => {
        return res.data;
      }).catch(err => {
        console.log('exportToExcel -> err', err);
        return [];
      });

      this.loadingExportFile = false;

      let dataToExport = [];
      list.map(item => {
        let vehicle = {
          'Thuộc Khách hàng (Parent)': item.dealerName,
          'Tên khách hàng': item.accountName,
          'Biển số': item.plate,
          'Trạng thái': this.getVehicleStatus(item),
          GPSTime:
            item.stateModel && item.stateModel.time ? item.stateModel.time : 0,
          Imei: item.imei,
          'SĐT Sim': item.simPhone,
          IccId: item.iccId,
          'Ngày kích hoạt': this.getDateFormatted(item.activatedDate),
          'Ngày còn lại': item.remainExpiryDay,
          'Ngày hết hạn': this.getDateFormatted(item.expiryDay),
          'Bị khóa': item.isLocked ? item.isLocked : '',
          'Ngày tạo': this.getDateFormatted(item.createdDate)
        };
        dataToExport.push(vehicle);
        return 0;
      });

      return dataToExport;
    },

    async exportFileDevice (file) {
      let params = {
        accountId: this.paginationParams.accountId,
        keySearch: '',
        pageIndex: file.index,
        pageSize: 10000,
      };

      this.loadingExportFile = true;

      let listDevice = await this.getDeviceByAccount(params).then(res => {
        return (res && res.data) || [];
      }).catch(err => {
        console.log('exportToExcel -> err', err);
        return [];
      });

      this.loadingExportFile = false;

      let dataToExport = [];
      listDevice.map(item => {
        let account = {
          'Thuộc Khách hàng (Parent)': item.dealerName,
          'Tên khách hàng': item.accountName,
          Imei: item.imei,
          'Loại TB': item.deviceType,
          'Gói cước': item.planCode,
          'SĐT Sim': item.simPhone,
          'Biển số xe': item.plate,
          'Ngày kích hoạt': item.activatedDate
            ? new Date(item.activatedDate).toISOString().slice(0, 10)
            : '',
          'Ngày tạo': new Date(item.createdDate).toISOString().slice(0, 10)
        };
        dataToExport.push(account);
        return 0;
      });
      return dataToExport;
    },

    async exportFileAccount (file) {
      let params = {
        accountId: this.paginationParams.accountId,
        keySearch: '',
        pageIndex: file.index,
        pageSize: 10000
      };

      this.loadingExportFile = true;

      let list = await this.getAccountByParent(params).then(res => {
        return res.data || [];
      }).catch(err => {
        console.log('exportToExcel -> err', err);
        return [];
      });

      this.loadingExportFile = false;

      let dataToExport = [];
      list.map(item => {
        let account = {
          'Thuộc Khách hàng (Parent)': item.dealerName,
          'Tên khách hàng': item.name,
          SĐT: item.phone,
          Email: item.email,
          'Số lượng xe': item.vehicle,
          'Số lượng thiết bị': item.device,
          'Số lượng simcard': item.sim,
          'Là Nhà phân phối': item.isDistributor,
          'Là Đại lý': item.isDealer,
          'Ngày tạo': new Date(item.createdDate).toISOString().slice(0, 10),
          'Lần chỉnh sửa cuối': new Date(item.modifiedDate)
            .toISOString()
            .slice(0, 10)
        };
        dataToExport.push(account);
        return 0;
      });
      return dataToExport;
    },

    async updateDtCode ({ id, dtCode }) {
      this.isLoading = true;

      try {
        await this.createDtMapping({
          accountId: id,
          code: dtCode
        });

        window.getApp.showMessage('Cập nhật DT Code thành công', 'success');

        this.reloadAccountTable(this.paginationParams);

        if (this.selectedAccount && this.selectedAccount.id === id) {
          this.selectedAccount.dtCode = dtCode;
        }
      } catch (err) {
        console.error(err);
        window.getApp.showMessage('Lỗi cập nhật DT Code', 'error');
      }

      this.isLoading = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/account/detail.vue